module.exports = __webpack_public_path__ + "static/media/check_1.87f3bfd9.svg";